import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Report} from '../reports/reports.model';
import {Injectable} from '@angular/core';
import {ProjectGroup, Type} from '../../pages/product/product.model';
import {ProjectTreeNode} from './project-tree.model';

@Injectable()
export class ProjectTreeService {
    taskTypes: Type[];
    phaseTypes: Type[];

    constructor(private _httpClient: HttpClient) { }


    getProjectGroup(id: number): Observable<ProjectGroup>{
        // const headers = { 'withCredentials':'true' }
        return this._httpClient.get<ProjectGroup>('/ypm/api/fm/projectGroup/' + id);
    }

    getPhaseTypes(): Observable<Type[]>{
        return this._httpClient.get<Type[]>('/ypm/api/fm/type/Phase');
    }

    getGeneralTaskTypes(): Observable<Type[]>{
        return this._httpClient.get<Type[]>('/ypm/api/fm/type/GeneralTask');
    }


    getChildren(id: number): Observable<ProjectTreeNode[]> {
        return this._httpClient.get<ProjectTreeNode[]>('/ypm/api/services/children/' + id);
    }

    createTreeNode(node: ProjectTreeNode): Observable<ProjectTreeNode> {
        return this._httpClient.put<ProjectTreeNode>('/ypm/api/services/children', node);
    }

    updateProjectGroup(entity: ProjectGroup): Observable<ProjectGroup>{
        return this._httpClient.post<ProjectGroup>('/ypm/api/services/children', entity);
    }


}
